<template>
    <nav class="languages" >
        <div class="trait"></div>

        <btn-flag lang="fr" @change="onChange"/>
        <!--btn-flag lang="mg" @change="onChange"/>
        <btn-flag lang="en" @change="onChange"/-->


    </nav>
</template>

<script>
    import BtnFlag from "shared-src/langues/BtnFlag";
    export default {
        name: "languages",
        components: {
            BtnFlag
        },
        methods:{
            onChange(langCode){
                this.$root.$emit("changeLanguage",langCode);
            }
        }
    }
</script>

<style lang="less">

    .languages{
        position: relative;
        .trait{
            position: absolute;
            left: calc( 50% - 25vw);
            top: 2.5vw;

            width: 50vw;
            height: 1px;
            background-color: white;
            display: block;
            @sz:0.3vw;
            &:before,&:after{

                position: absolute;
                top: calc( -1 * @sz);
                display: block;
                content: "";
                width: 0;
                height: 0;
                border-top: @sz solid transparent;
                border-bottom: @sz solid transparent;
                border-left: @sz solid white;
            }
            &:before{
                left: 0;
            }
            &:after{
                right: 0;

                border-left: none;
                border-right: @sz solid white;
            }
        }
    }


</style>